
import { ApiChat } from "../../../api/types";
import { DEBUG } from "../../../config";
import React, { FC, useState, useEffect } from "../../../lib/teact/teact";
import buildClassName from "../../../util/buildClassName";
import Avatar from "../../common/Avatar";
import ListItem from "../../ui/ListItem";
import { DBManager } from "../db/dbManager";
import store from "../store";
import LotCheckBox from "../ui/lotCheckBox";
import { getDateString, secondsToDateString } from "../utils/DateTimeUtils";

type OwnProps = {
    chat: ApiChat
    onChatClicked: (chat: ApiChat) => void;
    inSelectMode: boolean;
    selected: boolean;
    onChangeSelectChatMode: (isSelectMode: boolean) => void;
    onSelectChat: (isSelect: boolean, chat: ApiChat) => void;
}

const TeleChatItem: FC<OwnProps> = ({
    chat,
    onChatClicked: onChatClicked,
    inSelectMode,
    selected,
    onChangeSelectChatMode,
    onSelectChat,
}) => {
    const workDate = store.getState().global.workDate
    const [state, setState] = useState({
        inboxMsgCount: 0,
        outboxMsgCount: 0,

        selected: false,
    })
    useEffect(() => {

    }, [workDate])
    function selectChat(isSelected: boolean) {
        setState(prev => ({ ...prev, selected: isSelected }))
        onSelectChat(isSelected, chat)
    }
    return (
        <div className=" common-container-row  full-width" id={"chat:" + chat.id}
            >
            <div className=" display-data">
                <ListItem leftElement={(
                    <Avatar
                        //photo={notPersonalPhoto}
                        noPersonalPhoto
                        //peer={user}
                        text={chat.title}
                        size="large"
                        className="personal-photo"
                    />
                )}
                    className="chat-item-clickable"
                    onClick={() => {
                        if (!inSelectMode)
                            onChatClicked(chat)
                        else {
                            selectChat(!state.selected)
                        }
                        if (DEBUG)
                            console.log('TelechatItem clicked')
                    }}
                 
                >
                <div className={buildClassName('contactItem')} style={"display:flex;width:100%"}>
                    <div>
                        {chat.title}
                    </div>
                    {/* {state.inboxMsgCount + state.outboxMsgCount > 0 &&
                            <div className="extraInfo">
                                Tin đến {state.inboxMsgCount}. Tin đi {state.outboxMsgCount}
                            </div>
                        } */}
                    <div>
                        {
                            (() => {
                                if (chat.lastMessage) {
                                    if (chat.lastMessage.content && chat.lastMessage.content.text && chat.lastMessage.content.text.text) {
                                        const tmp = chat.lastMessage.content.text.text.substring(0, 60)
                                        return <div className="extraInfo">{tmp}</div>
                                    }
                                }
                                return <></>
                            })()
                        }
                    </div>
                </div>
                <div>
                    {inSelectMode && <LotCheckBox checked={selected} />}
                </div>
                </ListItem>
            </div>
        </div>
    )
}

export default TeleChatItem;